// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3JjEP","paramInput":"JobSimulator_paramInput__oSMO0","input":"JobSimulator_input__uJuGW"};